import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';
import { useModal } from 'Store/modal';
import { useAppSystem } from 'Store/app';
import postCancelHelpRequest from 'Api/host-help-partner/postCancelHelpRequest';
import { cancelHelpHostText } from 'Const/host-help-partner/domain';

import postCancelHelpRequestPayload from './model/request/postCancelHelpRequest';
import { isArray } from 'lodash';

const usePostCancelHelpRequest = () => {
  const { t } = useTranslation('host-help-partner');
  const navigate = useNavigate();
  const { onChangeAppSystem } = useAppSystem();
  const { onOpenToast } = useToast();
  const { onResetModal, onHideModal, onShowModal } = useModal();
  const { onShowLoader, onResetLoader } = useLoader();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (helpRequestId) => {
      onHideModal();

      onShowLoader({ variant: 'loader-primary' });

      const payload = postCancelHelpRequestPayload({ helpRequestId });

      const result = await postCancelHelpRequest(payload);

      return result;
    },
    onSuccess: async () => {
      onOpenToast({
        status: 'success',
        title: 'Success',
        description: t('cancel.success_message'),
        duration: 5,
        alwaysShow: false,
      });

      queryClient.invalidateQueries({
        queryKey: ['help-request-status'],
      });
      navigate(-1);
      onChangeAppSystem({ isHideMobileNavBar: false });
    },
    onError: (error) => {
      console.log(error);

      const errorMessage = isArray(error?.response?.data?.errors) ? error?.response?.data?.errors[0]?.message : cancelHelpHostText.defaultErrorDesc;

      onOpenToast({
        status: 'error',
        title: 'Error',
        description: errorMessage,
        duration: 5,
        alwaysShow: false,
      });

      onShowModal();
    },
    onSettled: () => {
      onResetModal();
      onResetLoader();
    },
  });
};

export default usePostCancelHelpRequest;
